import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import {
  SezioneEsitiLiquidatiAdapter
} from 'src/app/common/components/fascicolo/esiti-add-liquidati/sezione-esiti-liquidati-adapter';
import { Controparte } from 'src/app/common/models/controparte';
import { SoggettoPratica } from 'src/app/common/models/tipologiche/soggetto-pratica';
import { ServicePathsSettings } from 'src/app/core/configuration/service-paths-settings';
import { OperationsService } from "../../../../core/services/operations.service";
import {
  EsitiLiquidatiAddComponent
} from '../../../components/fascicolo/esiti-add-liquidati/esiti-add-liquidati.component';
import { DescrittoreSezione } from "../../../models/descrittore-sezione";
import { SezioneEsitiResponse } from "../../../models/dto/sezione-esiti-response";
import { Esito } from "../../../models/esito";
import { FascicoloFull } from "../../../models/fascicolo/fascicolo-full";
import { Liquidato } from "../../../models/liquidato";
import { SezioneEconomica } from "../../../models/sezioni/sezione-economica";
import { SezioneEsitiFull } from "../../../models/sezioni/sezione-esiti-full";
import { NumericOperationManager } from "../../../utils/numeric-operation-manager";
import { UtilityCommon } from "../../../utils/utility-common";
import { AltraParte } from 'src/app/common/models/altraparte';
import { LegaleIncaricato } from 'src/app/common/models/legale-incaricato';
import { ImportiComponent } from '../importi/importi.component';

@Component({
  selector: 'app-liquidati-view',
  templateUrl: './liquidati-view.component.html',
  styleUrls: ['./liquidati-view.component.css']
})
export class LiquidatiViewComponent extends ImportiComponent implements OnInit {
  @Input() descrittore: DescrittoreSezione;
  @Input() sezione: SezioneEconomica;
  @Input() fascicolo: FascicoloFull;
  @Input() isViewTerzoPignorato: boolean;
  @Input() labelComplessivo: string;
  @Input() idSezioneClassificazioni: string;
  @Output() openModaleLiquidatiUpdate: EventEmitter<Liquidato> = new EventEmitter<Liquidato>();
  @Output() emptyLiquidati: EventEmitter<any> = new EventEmitter<any>();
 
  listaSocieta: SoggettoPratica[]=[];
  listaControparti: Controparte[]=[];
  listaEsiti: Esito[] = [];
  sezioneEsiti: SezioneEsitiFull;
  listaLiquidati = []

  @ViewChild('modaleLiquidatiEdit') modaleLiquidatiEdit: EsitiLiquidatiAddComponent;

  calcolaSomma = UtilityCommon.calcolaSomma;
  constructor(private operationService: OperationsService) {
    super();
  }

  ngOnInit() {
    if (this.fascicolo.idSezioneEsiti) {
      this.readSezioneEsiti();
    }
  }

  getUrlReadSezione() {
    return "/rs/ops/gp/"+ this.fascicolo.praticaBase.tipoPratica.endpoint + "/fasc/" + this.fascicolo.tipoFascicolo.endpoint + "/sez/esiti";
  }

  getUrlRemoveLiquidati(){
    return "/rs/ops/gp/"+ this.fascicolo.praticaBase.tipoPratica.endpoint + "/fasc/" + this.fascicolo.tipoFascicolo.endpoint + "/{idFascicolo}/sez/economici/{idSezione}/liquidati";
  }

  getUrlUpdateEsito(){
    return "/rs/ops/gp/"+ this.fascicolo.praticaBase.tipoPratica.endpoint + "/fasc/" + this.fascicolo.tipoFascicolo.endpoint + "/sez/esiti/{idSezione}/esito";
  }

  getUrlInsertLiquidati(): string {
    return ServicePathsSettings.OPERATIONS_PATH + ServicePathsSettings.GESTIONE_PRATICHE_PATH + '/' + this.fascicolo.praticaBase.tipoPratica.endpoint + '' + ServicePathsSettings.URL_FASCICOLO + '/' + this.fascicolo.tipoFascicolo.endpoint + ServicePathsSettings.URL_INSERT_LIQUIDATI_ESITO;
  }

  getUrlEditLiquidati(): string {
    return ServicePathsSettings.OPERATIONS_PATH + ServicePathsSettings.GESTIONE_PRATICHE_PATH + '/' + this.fascicolo.praticaBase.tipoPratica.endpoint + '' + ServicePathsSettings.URL_FASCICOLO + '/' + this.fascicolo.tipoFascicolo.endpoint + ServicePathsSettings.URL_EDIT_LIQUIDATI_ESITO;
  }

  getUrlReadSezioneClassificazioni(): string {
    return ServicePathsSettings.OPERATIONS_PATH + ServicePathsSettings.GESTIONE_PRATICHE_PATH + '/' + this.fascicolo.praticaBase.tipoPratica.endpoint + '/prat/sez/classificazioni';
  }

  getUrlReadSezioneAltreParti(): string {
    return ServicePathsSettings.OPERATIONS_PATH + ServicePathsSettings.GESTIONE_PRATICHE_PATH + '/' + this.fascicolo.praticaBase.tipoPratica.endpoint + '/fasc/' + this.fascicolo.tipoFascicolo.endpoint + '/sez/altreparti';
  }

  getUrlReadSezioneLegali(): string {
    return ServicePathsSettings.OPERATIONS_PATH + ServicePathsSettings.GESTIONE_PRATICHE_PATH + '/' + this.fascicolo.praticaBase.tipoPratica.endpoint + '/fasc/' + this.fascicolo.tipoFascicolo.endpoint + '/sez/legali';
  }

  readSezioneEsiti() {
    this.operationService.readSezione(this.getUrlReadSezione(), this.fascicolo.idSezioneEsiti).subscribe(response =>{
      this.setSezioneEsiti((<SezioneEsitiResponse>response).sezione);
    });
  }

  setSezioneEsiti(sezioneResponse: SezioneEsitiFull) {
    // this.sezione = sezioneResponse;
    this.listaEsiti = sezioneResponse.esiti.filter(el=>el.liquidati && el.liquidati.length>0);
    console.log(this.listaEsiti)
    this.sezioneEsiti = sezioneResponse;
    if(this.listaEsiti.length===0) this.emptyLiquidati.emit();
    this.createListSocieta();
    this.updateImporti();
    this.getListaLiquidati();
  }

  getListaLiquidati(){
    this.listaLiquidati = [];
    this.listaEsiti.forEach(esito => {
      esito.liquidati.forEach(liquidato => this.listaLiquidati.push(liquidato))
    })
  }
  

  createListSocieta(){
    this.listaSocieta=[];
    this.listaEsiti.forEach(esito=>{
      esito.liquidati.forEach(liquidato=>{
        if(liquidato.societa && !this.listaSocieta.find(el=>el.id===liquidato.societa.id)){
          this.listaSocieta.push(liquidato.societa);
        }
      });
    });
    this.listaSocieta=this.listaSocieta.sort((leftSide, rigthSide): number => {
      if (leftSide.nome < rigthSide.nome) return -1;
      if (leftSide.nome > rigthSide.nome) return 1;
      return 0;
  });
  }

  updateImporti(){
    this.sorteTot=0;
    this.interessiTot=0;
    this.rivalutazioneTot=0;
    this.speseLiteTot=0;
    this.compensoTot = 0;
    this.speseLiquidateTot = 0;
    this.irapTot = 0;
    this.oneriRiflessiTot = 0;
    this.speseMarcheNotificaTot = 0;
    this.art96CPCTot = 0;
    this.f23Tot = 0;
    this.risarcimentoTot = 0;      
    this.speseGenTot = 0;
    this.cpaTot=0;
    this.ivaTot=0;
    this.ritenutaAccontoTot=0;
    this.speseRegistrazioneTot=0;
    this.contributoUnificatoTot=0;
    this.altroImportoTot=0;
    this.listaEsiti.forEach(esito=>{
      esito.liquidati.forEach(el=>{
        this.calculate(el);
      })
    })
  }

  

  displayEditLiquidatiModal(esito: Esito){
    this.modaleLiquidatiEdit.inizializza(this.getUrlEditLiquidati(), this.sezioneEsiti, esito, this.fascicolo, false, this.getUrlReadSezioneClassificazioni(), this.idSezioneClassificazioni, this.getUrlReadSezioneAltreParti(), this.fascicolo.idSezioneAltreParti, this.getUrlReadSezioneLegali(), this.fascicolo.idSezioneLegali);
  }

  removeLiquidatiFromEsito(esito: Esito) {
    esito.liquidati.forEach(liquidato => {
      liquidato.idEsito = esito.id;
      liquidato.daEliminare = true})
    this.operationService.eliminaLiquidati(this.getUrlRemoveLiquidati(), this.fascicolo.id, this.sezione.id, esito.liquidati).subscribe(response=>{
      if(response){
        this.readSezioneEsiti();
      }
    })
    /*this.operationService.deleteLiquidati(this.getUrlRemoveLiquidati(), this.fascicolo.id, this.sezione.id, esito.liquidati).subscribe(res => {
      if(res){
        this.readSezioneEsiti();
      }
    })*/
    //this.operationService.setEsitoInSezesiti(this.getUrlUpdateEsito(), this.fascicolo.idSezioneEsiti, esito).subscribe(response=>this.setSezioneEsiti((<SezioneEsitiResponse>response).sezione));
  }

  getTotaleSpeseDiLite(): number {
    return this.approssimaImporto(this.compensoTot) +
           this.approssimaImporto(this.speseLiquidateTot) +
           this.approssimaImporto(this.irapTot) +
           this.approssimaImporto(this.oneriRiflessiTot) +
           this.approssimaImporto(this.speseMarcheNotificaTot) +
           this.approssimaImporto(this.art96CPCTot) +
           this.approssimaImporto(this.f23Tot) +
           this.approssimaImporto(this.risarcimentoTot) +
           this.approssimaImporto(this.cpaTot) +
           this.approssimaImporto(this.ivaTot) +
           this.approssimaImporto(this.speseGenTot) -
           this.approssimaImporto(this.ritenutaAccontoTot);
  }

  getLiquidatiPerSocieta(societa):Liquidato[]{
    let liquidati: Liquidato[]=[];
    this.listaEsiti.forEach(esito=>{
      esito.liquidati.forEach(liquidato=>{
        if(liquidato.societa && liquidato.societa.id===societa.id) liquidati.push(liquidato);
      });
    });
    return liquidati;
  }

  getListLiquidatiControparti():Liquidato[]{
    let liquidati: Liquidato[]=[];
    if(this.listaEsiti){
      this.listaEsiti.filter(element=>element.liquidati.find(el=>!!el.controparte || !!el.altraParte || !!el.legaleIncaricato)).forEach(esito=>{
        esito.liquidati.forEach(liquidato=>{
          if(!liquidati.find(element=>element.controparte.id===liquidato.controparte.id || element.altraParte.id===liquidato.altraParte.id || element.legaleIncaricato.id===liquidato.legaleIncaricato.id)){
            liquidati.push(this.getLiquidatoTot(liquidato.controparte, liquidato.altraParte, liquidato.legaleIncaricato));
          }
        });
      });
    }
      liquidati=liquidati.sort((leftSide, rightSide): number => {
        if (leftSide.altraParte && rightSide.altraParte) {
          if (leftSide.controparte.parte.nominativo < rightSide.controparte.parte.nominativo) return -1;
          if (leftSide.controparte.parte.nominativo > rightSide.controparte.parte.nominativo) return 1;
        }

        if (leftSide.altraParte && rightSide.altraParte) {
          if (leftSide.altraParte.parte.nominativo < rightSide.altraParte.parte.nominativo) return -1;
          if (leftSide.altraParte.parte.nominativo > rightSide.altraParte.parte.nominativo) return 1;
        }
        if (leftSide.legaleIncaricato && rightSide.legaleIncaricato) {
            if (leftSide.legaleIncaricato.legale.nominativo < rightSide.legaleIncaricato.legale.nominativo) return -1;
            if (leftSide.legaleIncaricato.legale.nominativo > rightSide.legaleIncaricato.legale.nominativo) return 1;
        }
        return 0;
    });
    return liquidati;
  }

  getLiquidatoTot(controparte: Controparte, altraParte: AltraParte, legaleIncaricato:LegaleIncaricato): Liquidato {
    let liquidato: Liquidato = new SezioneEsitiLiquidatiAdapter(new Liquidato()).liquidato;
    liquidato.importoLiquidato.importo=0;
    liquidato.importoLiquidato.interessi=0;
    liquidato.importoLiquidato.sanzioni=0;
    liquidato.costoGestioneLiquidato.compenso = 0;
    liquidato.altroImportoLiquidato.altroImporto=0;
    liquidato.altroImportoLiquidato.speseRegistrazione=0;
    liquidato.altroImportoLiquidato.contributoUnificato=0;
      this.listaEsiti.filter(esito=>esito.liquidati.find(el=>!!el.controparte || !!el.altraParte || !!el.legaleIncaricato)).forEach(esito=>{
          esito.liquidati.forEach(element=>{
            if(element.controparte.id===controparte.id || element.altraParte.id===altraParte.id || element.legaleIncaricato.id===legaleIncaricato.id){
              liquidato.controparte = controparte;
              liquidato.altraParte = altraParte;
              liquidato.legaleIncaricato = legaleIncaricato;
              liquidato.tipoLiquidato=element.tipoLiquidato;
              liquidato.societa = element.societa;
              liquidato.importoLiquidato.importo = Number(liquidato.importoLiquidato.importo) + Number(element.importoLiquidato.importo);
              liquidato.importoLiquidato.interessi = Number(liquidato.importoLiquidato.interessi) + Number(element.importoLiquidato.interessi);
              liquidato.importoLiquidato.sanzioni = Number(liquidato.importoLiquidato.sanzioni) + Number(element.importoLiquidato.sanzioni);
              liquidato.costoGestioneLiquidato.compenso = Number(liquidato.costoGestioneLiquidato.compenso) + Number(element.costoGestioneLiquidato.compenso);
              liquidato.costoGestioneLiquidato.iva = element.costoGestioneLiquidato.iva;
              liquidato.costoGestioneLiquidato.cpa = element.costoGestioneLiquidato.cpa;
              liquidato.costoGestioneLiquidato.flagRitenutaAcconto = element.costoGestioneLiquidato.flagRitenutaAcconto;
              liquidato.altroImportoLiquidato.altroImporto = Number(liquidato.altroImportoLiquidato.altroImporto) + Number(element.altroImportoLiquidato.altroImporto);
              liquidato.altroImportoLiquidato.speseRegistrazione = Number(liquidato.altroImportoLiquidato.speseRegistrazione) + Number(element.altroImportoLiquidato.speseRegistrazione);
              liquidato.altroImportoLiquidato.contributoUnificato = Number(liquidato.altroImportoLiquidato.contributoUnificato) + Number(element.altroImportoLiquidato.contributoUnificato);
            }
          });
      });
    return liquidato;
  }

  sommaLiquidatiPerSocieta(societa) {
    let totPerSocieta = 0;
    this.listaEsiti.forEach(esito=>{
      esito.liquidati.forEach(liquidato=>{
        if(liquidato.societa && liquidato.societa.id===societa.id){
          totPerSocieta+=this.totaleImportiLiquidato(liquidato);
        }
      });
    });
    return totPerSocieta;
  }

  totaleImportiLiquidato(liquidato: Liquidato):number{
    let totale = 0;
    totale+=Number(liquidato.importoLiquidato.importo)+Number(liquidato.importoLiquidato.interessi)+Number(liquidato.importoLiquidato.sanzioni);
    let cpaImporto = liquidato.costoGestioneLiquidato.cpa ? Number(liquidato.costoGestioneLiquidato.compenso) * (liquidato.costoGestioneLiquidato.cpa.valore/100) : 0;
    let ivaImporto = liquidato.costoGestioneLiquidato.iva ? Number(liquidato.costoGestioneLiquidato.compenso) * (liquidato.costoGestioneLiquidato.iva.valore/100) : 0;
    let ritenutaAcconto = liquidato.costoGestioneLiquidato.flagRitenutaAcconto ? Number(liquidato.costoGestioneLiquidato.compenso) * 0.2 : 0;
    totale += (Number(liquidato.costoGestioneLiquidato.compenso)+cpaImporto+ivaImporto) - ritenutaAcconto;
    totale += Number(liquidato.altroImportoLiquidato.contributoUnificato)+Number(liquidato.altroImportoLiquidato.speseRegistrazione)+Number(liquidato.altroImportoLiquidato.altroImporto);
    return totale;
  }

}

